import { render, staticRenderFns } from "./CenterList.vue?vue&type=template&id=31387c2a&"
import script from "./CenterList.vue?vue&type=script&lang=ts&"
export * from "./CenterList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports